import { selectAuthState } from '@/selectors/auth';
import { useAppSelector } from './useAppSelector';
import { ACTION, ALLOWED_ROLES, APP_SCOPE } from '@/constants';

export const useRole = (scope: APP_SCOPE) => {
  const authState = useAppSelector(selectAuthState);
  const user = authState?.user ?? null;

  const scopeRoles = ALLOWED_ROLES[scope];
  const checkAccess = (action: ACTION): boolean =>
    !!user && !!scopeRoles?.[action]?.includes(user.role);

  return {
    canDelete: checkAccess(ACTION.DELETE),
    canCreate: checkAccess(ACTION.CREATE),
    canUpdate: checkAccess(ACTION.UPDATE),
    canRead: checkAccess(ACTION.READ)
  };
};
